export default {
  master_title: 'Brandtilstand – menu',
  title: 'Menu',
  form: {
    has_internal_product_numbers: {
      label: 'Tildel produktnumre',
      tooltip:
        'Tildel automatisk numre til produkter ud fra deres placering i menuen. Nummeret printes på kvitteringerne',
    },
  },
  buttons: {
    new_menu: 'Ny menu',
    export_menu: 'Eksportér menu',
    refresh: 'Opdater',
  },
  modals: {
    delete_category: {
      title: 'Slet {{name}}',
    },
    delete_products: {
      title: 'Slet {{count}} produkter?',
      description: '<strong>{{count}}</strong> fjernes fra menuen',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_delete_menu: 'Menuen kunne ikke slettes, prøv igen',
    menu_got_deleted: 'Menuen er slettet',
    failed_to_delete_category: 'Kategorien kunne ikke slettes, prøv igen',
    category_got_deleted: 'Kategorien er slettet',
    failed_to_delete_products: 'Produkterne kunne ikke slettes, prøv igen',
    product_got_deleted_one: 'Produktet er slettet',
    product_got_deleted_other: 'Produkterne er slettet',
    failed_to_generate_product_number: 'Noget gik galt. Genindlæs siden, og prøv igen',
    menu_exported: 'Menuen er eksporteret',
    failed_to_export_menu: 'Menuen kunne ikke eksporteres',
  },
};
